import { CONFIG } from '../../../core/config';
import { OperationResult } from '../../../shared/operation-result';
import { ViewModel } from '../../view-model';
import { ErpMitigationJob } from './erp-mitigation-job';

export class ErpMitigationJobs implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'ERP Mitigation Jobs';
  readonly apiRoute: string = CONFIG.apiRoutes.erpMaintenanceJobs;

  jobs: ErpMitigationJob[];

  json() {
    return this;
  }
  loadFromJson(data: any) {
    this.jobs = data.jobs;
  }
}
